<template>
  <div class="item-selector row">
    <div class="col-md-6">
      <div v-if="item.item_id" class="selected-item">
        {{ item.name }}

        <span class="deselect-icon" @click="deselectItem">
          <font-awesome-icon icon="times-circle" />
        </span>
      </div>
      <base-select
        v-else
        ref="baseSelect"
        v-model="itemSelect"
        :options="items"
        :show-labels="false"
        :preserve-search="true"
        :initial-search="item.name"
        :searchable="true"
        :invalid="invalid"
        :placeholder="$t('pos.item.select_an_item')"
        label="name"
        class="multi-select-item"
        @select="(val) => $emit('select', val)"
      >
        <template #option="{ option }">
          <div @mouseover="showItemInfo(option)" @click="selectItem(option)">
            {{ option.name }}
            <div v-if="hoveredOption === option" class="item-info">
              <p>Name: {{ option.name }}</p>
              <p>Part: {{ option.part_number }}</p>
              <p>Price: {{ formatPrice(option.price) }}</p>
            </div>
          </div>
        </template>
        <div slot="afterList">
          <button type="button" class="list-add-button" @click="openItemModal">
            <font-awesome-icon class="icon" icon="cart-plus" />
            <label>{{ $t('general.add_new_item') }}</label>
          </button>
        </div>
        <div class="item-description">
          <base-text-area
            v-autoresize
            v-model.trim="item.description"
            :invalid-description="invalidDescription"
            :placeholder="$t('pos.item.type_item_description')"
            type="text"
            rows="1"
            class="description-input"
            @input="$emit('onDesriptionInput')"
          />
          <div v-if="invalidDescription">
            <span class="text-danger">{{ $tc('validation.description_maxlength') }}</span>
          </div>
        </div>
    </base-select></div>
    <div class="col-md-6">
      <div v-if="item.item_id" class="selected-item">
        {{ item.part_number }}

        <span class="deselect-icon" @click="deselectItem">
          <font-awesome-icon icon="times-circle" />
        </span>
      </div>
      <base-select
        v-else
        ref="baseSelect"
        v-model="itemSelect"
        :options="items"
        :searchable="true"
        :show-labels="false"
        :preserve-search="true"
        :initial-search="item.part_number"
        :invalid="invalid"
        :placeholder="$t('pos.item.select_an_item')"
        label="part_number"
        class="multi-select-item"
        @select="(val) => $emit('select', val)"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    invalid: {
      type: Boolean,
      required: false,
      default: false
    },
    invalidDescription: {
      type: Boolean,
      required: false,
      default: false
    },
    invalidPartNumber: {
      type: Boolean,
      required: false,
      default: false
    },
    taxPerItem: {
      type: String,
      default: ''
    },
    taxes: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
      itemSelect: null,
      loading: false,
      hoveredOption: null
    }
  },
  computed: {
    ...mapGetters('item', [
      'items'
    ])
  },
  watch: {
    invalidDescription (newValue) {
      console.log(newValue)
    },
    invalidPartNumber (newValue) {
      console.log(newValue)
    }
  },
  methods: {
    ...mapActions('modal', [
      'openModal'
    ]),
    ...mapActions('item', [
      'fetchItems'
    ]),
    async searchItems (search) {
      let data = {
        filter: {
          name: search,
          unit: '',
          price: ''
        },
        orderByField: '',
        orderBy: '',
        page: 1
      }

      this.loading = true

      await this.fetchItems(data)

      this.loading = false
    },
    onTextChange (val) {
      this.searchItems(val)

      this.$emit('search', val)
    },
    openItemModal () {
      this.$emit('onSelectItem')
      this.openModal({
        'title': 'Add Item',
        'componentName': 'ItemModal',
        'data': {taxPerItem: this.taxPerItem, taxes: this.taxes}
      })
    },
    deselectItem () {
      this.itemSelect = null
      this.$emit('deselect')
    },
    showItemInfo (option) {
      this.hoveredOption = option
    },

    selectItem (option) {
      this.itemSelect = option
      this.$emit('select', option)
    },
    formatPrice (price) {
      return (price).toFixed(2)
    }
  }
}
</script>
